import ReportsForm from './ReportsForm';

export default ReportsForm;